export default __webpack_public_path__ + "static/media/favicon.84ca3396.ico";